import {Component} from 'preact';
import shallowCompare from 'preact-shallow-compare';
import {format} from 'date-fns';
import {toCurrency} from '@util/NumberUtil';
import ProductImage from '@components/common/ProductImage';
import AddCartButton from '@components/common/AddCartButton';

export class LineItem extends Component {
    constructor ( props ) {
        super( props );

        // note: these state props not in use
        this.state = {
            sku: props.product.sku
        };
    }

    componentDidMount () {
        if ( this.addBtn.base.firstChild ) {
            const aTag = this.addBtn.base.firstChild.querySelector( 'a' );
            aTag && upi.Site.tracking.applyPromoViewTracking( aTag );
        }
    }

    shouldComponentUpdate ( nextProps, nextState ) {
        return shallowCompare( this, nextProps, nextState );
    }

    render ( props, state, context ) {
        const {product, dataLayer = {}} = props;
        const displayPrice = product.customerPrice || product.catalogPrice;
        const priceRestricted = displayPrice === -1;

        return (
            <Wrapper id={product.sku} data-testid="past-purchase-line-item">
                <PurchaseDate date={product.orderDate}/>
                <Body>
                    <Figure>
                        <ProductImage {...product} width="90"/>
                    </Figure>
                    <Sku sku={product.sku}/>
                    <Title>{product.kitName}</Title>
                    <PriceLine>
                        <PriceDisplay price={displayPrice} priceRestricted={priceRestricted}/>
                    </PriceLine>
                </Body>
                <AddButton ref={ref => this.addBtn = ref} product={product} {...dataLayer}/>
            </Wrapper>
        );
    }
}

export default LineItem;

/**
 * * **************************************************
 *
 * LineItem Layout Components
 * - Layout helpers for building line item components
 *
 * **************************************************
 */
function formatPrice ( price ) {
    if ( price === 0 ) {
        return 'Free';
    }

    return `$${toCurrency( parseFloat( price, 10 ) )} ea.`;
}

export const Wrapper = ( {id, children} ) =>
    <div id={`lineItem_${id}`}
         className="flex flex-wrap select-none relative float-none py-3 border-b border-solid border-grey-lighter">
        {children}
    </div>;

export const Figure = ( {children} ) =>
    <div className="float-left p-2 mr-2 border border-solid border-grey-lighter bg-white w-16">
        <div className="img-ratio-4x3">
            {children}
        </div>
    </div>;

export const Body = ( {children} ) =>
    <div className="w-auto md:w-1/2 px-1 overflow-hidden">
        {children}
    </div>;

const AddButton = ( {product, ...rest} ) =>
    <div className="self-end w-full md:w-1/2 md:pl-4">
        <AddCartButton product={product} {...rest}/>
    </div>;

export const Sku = ( {sku} ) =>
    <div className="text-subtitle" data-sx-product-sku>
        #{sku.replace( /\-$/, '' )}
    </div>;

export const PriceDisplay = ( {price, priceRestricted} ) => {
    if ( priceRestricted ) {
        return <span className="text-sm inline-block ml-1 txt-c1">Price unavailable</span>;
    }

    return (
        <span className="text-body inline-block" data-sx-product-price>
            {formatPrice( price )}
        </span>
    );
};

export const PriceLine = ( {children} ) =>
    <span className="mb-2">{children}</span>;

export const QtyField = ( {children} ) =>
    <div className="pin-l inline-block relative">{children}</div>;

export const TitleLink = ( {children, href = '/'} ) =>
    <a href={href}>
        <p data-sx-product-name
           className="text-subtitle mb-1 block">{children}</p>
    </a>;
export const Title = ( {children} ) =>
    <p data-sx-product-name
       className="text-subtitle mb-1 block">{children}</p>

export const PurchaseDate = ( {date} ) => {
    return <div className="w-full text-title clear pb-2 w-full">{format( new Date( date ), 'MMMM d, yyyy' )}</div>;
}


